
        var result = require("!!../../../../node_modules/css-loader/index.js!./forgot-password.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/forgot-password/forgot-password.component.css
// module id = 718
// module chunks = 0